import { Text } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { ReactNode } from 'react';

import s from './fieldSet.module.scss';

export function FieldSet({
  children,
  legend,
  classNames,
}: {
  children: ReactNode;
  legend: string;
  classNames?: {
    fieldset?: string;
    legend?: string;
    legendText?: string;
  };
}): JSX.Element {
  return (
    <fieldset className={cx(s.fieldSet, classNames?.fieldset)}>
      <legend className={cx(s.fieldSetLegend, classNames?.legend)}>
        <Text.Paragraph variant="3" subdued className={classNames?.legendText}>
          {legend}
        </Text.Paragraph>
      </legend>
      {children}
    </fieldset>
  );
}
